import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { FormControl, FormControlName, FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-input-counter',
  templateUrl: './input-counter.component.html',
  styleUrls: ['./input-counter.component.scss'],
})
export class InputCounterComponent implements OnInit {
  @Input() fieldIndex: number;
  @Input() max: number = 5;
  @Input() counterButton = true;
  @Input() counterPrefix = { show: false, label: '' };
  @Output() counterChange = new EventEmitter<number>();

  form: FormGroup;
  counter: FormControl;

  get counterValue() {
    return this.counter.value;
  }

  constructor(
    private formGroupDirective: FormGroupDirective,
    private formControlNameDirective: FormControlName
  ) {}

  ngOnInit(): void {
    this.form = this.formGroupDirective.form;
    this.counter = this.formGroupDirective.getControl(this.formControlNameDirective);
  }

  patchCounterValue(val: number) {
    this.counter.patchValue(val);
    this.counterChange.emit(val);
  }

  increment() {
    const nextVal = (this.counterValue || 0) + 1;
    this.patchCounterValue(nextVal);
  }

  decrement() {
    const prevVal = this.counterValue - 1;
    const finalVal = this.isValidCounter(prevVal) ? prevVal : this.max;
    this.patchCounterValue(finalVal);
  }

  handleChangeOnTyping(e: Event) {
    const input = e.target as HTMLInputElement;
    let val = this.formatInputElementValue(input.value);

    if (!this.isValidCounter(val)) {
      val = this.max;
    }

    this.patchCounterValue(val);
  }

  formatInputElementValue(val: string) {
    const sanitized = val.toString().replace(/\D/g, '').replace(/^0+/, '');
    return sanitized === '' ? 0 : Number(sanitized);
  }

  isValidCounter(val: number) {
    if (!val && val !== 0) return true;
    return val >= 0 && val < this.max;
  }

  buttonAddShouldDisabled() {
    return !this.isValidCounter(this.counterValue);
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
